import { render, staticRenderFns } from "./dialogRoute.vue?vue&type=template&id=2ff01bba&"
import script from "./dialogRoute.vue?vue&type=script&lang=js&"
export * from "./dialogRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports